var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPallete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 433.05 86.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#51127f;}.cls-2{fill:#1900da;}.cls-3{fill:#1b950c;}.cls-4{fill:#7a0708;}.cls-5{fill:#d70a84;}.cls-6{fill:#0feded;}.cls-7{fill:#aef611;}.cls-8{fill:#ed2100;}.cls-9{fill:#ff4d1d;}.cls-10{fill:#ffcb05;}.cls-11{fill:#d6dced;}.cls-12{fill:#687c86;}.cls-13{fill:#7e1790;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.22,
    width: 43.3,
    height: 43.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.52,
    width: 43.3,
    height: 43.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.83,
    width: 43.3,
    height: 43.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 346.44,
    width: 43.3,
    height: 43.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 389.74,
    width: 43.3,
    height: 43.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 173.22,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 216.52,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 259.83,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 346.44,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 303.13,
    width: 43.3,
    height: 43.3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 303.13,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 389.74,
    y: 43.3,
    width: 43.3,
    height: 43.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 86.61,
    width: 86.61,
    height: 86.61
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    width: 86.61,
    height: 86.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPallete);
export default __webpack_public_path__ + "static/media/colorPallete.6986428c647f646742dfd59d88df3d49.svg";
export { ForwardRef as ReactComponent };